import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme, useMediaQuery } from '@mui/material';

import Icon from '../Icon/Icon';

const FormInput = ({
  type,
  style,
  valid,
  placeholder,
  fieldProps,
  ...additionalProps
}) => {
  const [inputType, setInputType] = useState('password');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const handleClick = () => {
    inputType === 'password' ? setInputType('text') : setInputType('password');
  };

  return (
    <div
      style={{ 
        ...style, 
        marginBottom: !placeholder ? '0' : '0.5rem',
        width: '100%'
      }}
      data-test="component-input"
      className="form-group"
    >
      <input
        className="form-group__input"
        type={type === 'password' ? inputType : type}
        placeholder={placeholder}
        style={{
          width: '100%',
          padding: !placeholder ? '1rem' : undefined,
          fontSize: '1.8rem',
          lineHeight: '1.5',
          fontFamily: 'inherit'
        }}
        {...fieldProps}
        {...additionalProps}
      />
      <span className="form-group__placeholder">{placeholder}</span>
      <div className="input-icons">
        {typeof valid === 'boolean' ? (
          valid ? (
            <Icon className="color-grey" icon="checkmark-circle-outline" />
          ) : (
            <Icon className="color-red" icon="close-circle-outline" />
          )
        ) : null}
        {type === 'password' && (
          <span 
            onClick={() => handleClick()} 
            className="form-group__toggle"
            style={{ fontSize: isMobile ? '0.8rem' : '1rem' }}
          >
            {inputType === 'password' ? 'Show' : 'Hide'}
          </span>
        )}
      </div>
    </div>
  );
};

FormInput.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
};

FormInput.defaultProps = {
  type: 'text',
};

export default FormInput;
